import React from 'react';
import { FileSpreadsheet, MessageCircle, BookOpen, FolderOpen, AlertTriangle, ArrowRight, Users, NotebookPen, ShieldCheck, BarChart3, CircleDollarSign, Music, HeartHandshake } from 'lucide-react';

export const TransitionSection = () => {
  const beforeItems = [
    { icon: FileSpreadsheet, label: 'Excel', color: 'text-emerald-600' },
    { icon: MessageCircle, label: 'WhatsApp', color: 'text-green-500' },
    { icon: BookOpen, label: 'Libretas', color: 'text-amber-600' },
    { icon: FolderOpen, label: 'Archivos', color: 'text-blue-500' },
    { icon: AlertTriangle, label: 'Información dispersa', color: 'text-rose-500' },
  ];

  const afterItems = [
    { icon: Users, label: 'Personas', color: 'bg-indigo-500' },
    { icon: NotebookPen, label: 'Formación', color: 'bg-purple-500' },
    { icon: ShieldCheck, label: 'Grupos', color: 'bg-amber-500' },
    { icon: BarChart3, label: 'Liderazgo', color: 'bg-emerald-500' },
    { icon: CircleDollarSign, label: 'Finanzas', color: 'bg-teal-500' },
    { icon: Music, label: 'Alabanza', color: 'bg-violet-500' },
    { icon: HeartHandshake, label: 'Consejería', color: 'bg-rose-500' },
  ];

  return (
    <section className="py-20 bg-slate-50 dark:bg-slate-950 border-t border-slate-200/60 dark:border-slate-800/60 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* HEADER */}
        <div className="text-center max-w-3xl mx-auto space-y-4 mb-16">
          <p className="text-xs font-black uppercase tracking-[0.2em] text-indigo-600 dark:text-indigo-400">
            La transformación
          </p>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 dark:text-white tracking-tight">
            De la información dispersa a{' '}
            <span className="bg-gradient-to-r from-indigo-600 to-violet-600 dark:from-indigo-400 dark:to-violet-400 bg-clip-text text-transparent">
              una iglesia organizada
            </span>
          </h2>
        </div>

        {/* BEFORE → AFTER VISUAL */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
          
          {/* BEFORE */}
          <div className="bg-white dark:bg-slate-900 rounded-[2.5rem] p-8 border border-2 border-dashed border-rose-200 dark:border-rose-900/50 space-y-6">
            <div className="text-center">
              <span className="inline-block px-4 py-1.5 bg-rose-100 dark:bg-rose-950/50 text-rose-700 dark:text-rose-300 rounded-full text-xs font-black uppercase tracking-wider">
                Antes
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-3">
              {beforeItems.map((item, idx) => (
                <div key={idx} className="flex items-center gap-2 px-4 py-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800">
                  <item.icon size={16} className={item.color} />
                  <span className="text-xs font-bold text-slate-700 dark:text-slate-300">{item.label}</span>
                </div>
              ))}
            </div>
            <p className="text-center text-xs font-medium text-slate-400 dark:text-slate-500">
              Información fragmentada en múltiples herramientas
            </p>
          </div>

          {/* ARROW */}
          <div className="hidden lg:flex items-center justify-center">
            <div className="w-20 h-20 rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 flex items-center justify-center shadow-xl shadow-indigo-500/30">
              <ArrowRight size={28} className="text-white" />
            </div>
          </div>

          {/* MOBILE ARROW */}
          <div className="flex lg:hidden items-center justify-center">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 flex items-center justify-center shadow-xl shadow-indigo-500/30 rotate-90">
              <ArrowRight size={24} className="text-white" />
            </div>
          </div>

          {/* AFTER */}
          <div className="bg-gradient-to-br from-indigo-900 via-violet-950 to-slate-900 rounded-[2.5rem] p-8 border border-indigo-500/30 space-y-6 shadow-2xl">
            <div className="text-center">
              <span className="inline-block px-4 py-1.5 bg-indigo-500/20 text-indigo-200 rounded-full text-xs font-black uppercase tracking-wider backdrop-blur-md">
                Con PastoreApp
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-2">
              {afterItems.map((item, idx) => (
                <div key={idx} className="flex items-center gap-2 px-3 py-2 bg-white/10 backdrop-blur-md rounded-xl border border-white/10">
                  <span className={`w-2 h-2 rounded-full ${item.color}`} />
                  <span className="text-xs font-bold text-white">{item.label}</span>
                </div>
              ))}
            </div>
            <p className="text-center text-xs font-medium text-indigo-200">
              Todo centralizado en una sola plataforma
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};
